export default {
  title: "Vendors",
  description: "Manage your wedding vendors",
  subtitle: "Add and manage your wedding vendors",
  addVendor: "Add Vendor",
  editVendor: "Edit Vendor",
  deleteVendor: "Delete Vendor",
  noVendors: "No vendors found",
  addFirstVendor: "Add your first vendor",
  hired: "Hired",
  engagedVendors: "Engaged Vendors",
  noEngagedVendors: "No engaged vendors yet",
  allVendors: "All Vendors",
  more: "more",
  vendorDeleted: "Vendor successfully deleted",
  vendorCreated: "Vendor successfully created",
  vendorUpdated: "Vendor successfully updated",
  totalVendors: "{{count}} vendors",
  
  categories: {
    venue: "Venue",
    religious_venue: "Religious Venue",
    city_hall: "City Hall",
    catering: "Catering",
    photography: "Photography",
    videography: "Videography",
    music: "Music",
    florist: "Florist",
    cake: "Cake",
    dress: "Dress",
    suit: "Suit",
    hair_makeup: "Hair & Makeup",
    decoration: "Decoration",
    transportation: "Transportation",
    flowers: "Flowers",
    transport: "Transport",
    beauty: "Beauty",
    other: "Other",
    select: "Select a category",
    none: "None",
    photos: "Photos",
    preparation: "Preparation",
    reminder: "Reminder",
    task: "Task",
    vendor: "Vendor",
    vendors: "Vendors",
    custom: "Custom"
  },

  form: {
    name: "Name",
    category: "Category",
    contact: "Contact",
    email: "Email",
    phone: "Phone",
    address: "Address",
    website: "Website",
    price: "Price",
    notes: "Notes",
    rating: "Rating",
    status: "Status",
    statusHelper: "Status determines budget and task management.",
    contactName: "Contact Name",
    deposit: "Deposit",
    depositPaid: "Deposit Paid",
    contractSigned: "Contract Signed",
    country: "Country",
    errors: {
      nameRequired: "Name is required",
      categoryRequired: "Category is required",
      statusRequired: "Status is required",
      pricePositive: "Price must be positive",
      depositPositive: "Deposit must be positive",
      capacityPositive: "Capacity must be a positive number"
    },
    new: "New Vendor",
    edit: "Edit Vendor",
    title: "Vendor Details",
    namePlaceholder: "Vendor Name",
    company: "Company",
    categoryPlaceholder: "Select a category",
    emailPlaceholder: "Email Address",
    phonePlaceholder: "Phone Number",
    websitePlaceholder: "Website URL",
    addressPlaceholder: "Vendor Address",
    notesPlaceholder: "Additional Notes",
    submit: "Save",
    cancel: "Cancel",
    confirmCancel: "Cancel",
    contactInfo: "Contact Information",
    capacity: "Maximum Capacity",
    capacityPlaceholder: "Maximum number of people",
    contactNamePlaceholder: "Contact Name",
    description: "Description",
    dueDate: "Due Date",
    priority: "Priority"
  },

  status: {
    contacted: "Contacted",
    quote: "Quote Received",
    booked: "Booked",
    hired: "Hired",
    deposit_paid: "Deposit Paid",
    paid: "Paid",
    cancelled: "Cancelled",
    to_contact: "To Contact",
    meeting_scheduled: "Meeting Scheduled",
    meetingScheduled: "Meeting Scheduled",
    quote_received: "Quote Received",
    quoteReceived: "Quote Received",
    depositPaid: "Deposit Paid",
    completed: "Completed",
    researching: "Researching",
    confirmed: "Confirmed",
    pending: "Pending",
    declined: "Declined"
  },

  actions: {
    save: "Save",
    cancel: "Cancel",
    delete: "Delete",
    edit: "Edit",
    contact: "Contact",
    book: "Book",
    add: "Add",
    addLong: "Add new vendor",
    importGuests: "Import guests"
  },

  messages: {
    vendorAdded: "Vendor added successfully",
    vendorUpdated: "Vendor updated successfully",
    vendorDeleted: "Vendor deleted successfully",
    error: "An error occurred",
    createSuccess: "Vendor added successfully",
    updateSuccess: "Vendor updated successfully",
    deleteSuccess: "Vendor deleted successfully",
    deleteConfirm: "Are you sure you want to delete this vendor?"
  },

  confirm: {
    delete: "Are you sure you want to delete this vendor?",
    budgetRemoval: {
      title: "Budget Removal",
      message: "Are you sure you want to delete the budget associated with this vendor?",
      confirm: "Yes, delete",
      cancel: "Cancel"
    }
  },

  confirmations: {
    delete: "Are you sure you want to delete this vendor?"
  },

  logs: {
    addingVendor: "Adding vendor...",
    updatingVendor: "Updating vendor..."
  },

  errors: {
    submit: "Error saving vendor",
    addVendor: "Error adding vendor",
    updateVendor: "Error updating vendor",
    deleteVendor: "Error deleting vendor",
    loadVendors: "Error loading vendors",
    userOrWeddingNotFound: "User or event not found"
  },

  search: {
    title: "Find Vendors",
    searchPlaceholder: "Search for vendors",
    locationPlaceholder: "City or zip code",
    categoryPlaceholder: "Select a category",
    sort: "Sort by",
    sortOptions: {
      relevance: "Relevance",
      rating: "Rating",
      reviews: "Reviews",
      distance: "Distance",
      name: "Name"
    },
    findVendors: "Find Vendors",
    googleShort: "Search",
    googlePlaceholder: "Search for a vendor",
    googleResults: "Search Results",
    googleNoResults: "No results found",
    googleError: "An error occurred during search",
    googleErrorShort: "Search error",
    locationRequired: "Please enter a location to search",
    countries: {
      FR: "🇫🇷 France",
      BE: "🇧🇪 Belgium",
      CH: "🇨🇭 Switzerland",
      ES: "🇪🇸 Spain",
      IT: "🇮🇹 Italy",
      DE: "🇩🇪 Germany",
      GB: "🇬🇧 United Kingdom",
      IE: "🇮🇪 Ireland",
      CA: "🇨🇦 Canada",
      US: "🇺🇸 United States",
      AU: "🇦🇺 Australia",
      OTHER: "🌍 Other"
    },
    filters: {
      title: "Filters",
      category: "Category",
      status: "Status",
      search: "Search",
      country: "Country",
      location: "Where?",
      radius: "Radius"
    },
    google: "Google Search",
    googleLong: "Search on Google (places, businesses, etc.)",
    placeholder: "City or zip code...",
    noResults: "No results found",
    noResultsDescription: "Try modifying your search criteria or expanding your geographic area.",
    reset: "Reset search",
    searching: "Searching",
    searchingDescription: "We are searching for the best vendors...",
    addVendor: "Add this vendor",
    add: "Add",
    site: "Website",
    phone: "Phone",
    resultsCountSingular: "vendor found",
    resultsCountPlural: "vendors found",
    reviews: "reviews",
    recommended: "Recommended",
    new: "New"
  },
  
  empty: {
    title: "No vendors",
    description: "Start adding your wedding vendors"
  },

  filters: {
    title: "Filters",
    category: "Category",
    status: "Status",
    all: "All",
    group: "Group",
    search: "Search vendor",
    events: "Events",
    clear: "Clear filters",
    apply: "Apply",
    previous: "Previous",
    next: "Next",
    reset: "Reset",
    allCategories: "All categories"
  },

  groups: {
    family: "Family",
    friends: "Friends",
    colleagues: "Colleagues",
    other: "Other"
  },

  events: {
    ceremony: "Ceremony",
    reception: "Reception",
    both: "Both"
  },

  sort: {
    title: "Sort by",
    options: {
      name: "Name",
      category: "Category",
      status: "Status",
      price: "Price",
      notes: "Notes"
    }
  },

  modal: {
    title: "Vendor Details",
    readOnly: "Read only",
    edit: "Edit",
    share: "Share",
    personalInfo: "Personal Information",
    companyInfo: "Company Information",
    contactInfo: "Contact Information",
    notes: "Notes",
    budget: "Budget",
    documents: "Documents",
    timeline: "Timeline",
    tasks: "Tasks",
    reviews: "Reviews",
    messages: "Messages",
    payments: "Payments",
    contracts: "Contracts"
  },

  details: {
    contact: "Contact",
    pricing: "Pricing",
    documents: "Documents",
    appointments: "Appointments",
    payments: "Payments"
  },

  vendors: {
    filters: {
      status: "Status",
      all: "All",
      group: "Group",
      events: "Events"
    },
    status: {
      confirmed: "Confirmed",
      pending: "Pending",
      declined: "Declined"
    },
    groups: {
      family: "Family",
      friends: "Friends",
      colleagues: "Colleagues",
      other: "Other"
    },
    events: {
      ceremony: "Ceremony",
      reception: "Reception",
      both: "Both"
    },
    sort: {
      options: {
        name: "Name",
        category: "Category",
        status: "Status",
        price: "Price",
        notes: "Notes"
      }
    }
  },

  success: {
    budgetUpdated: "Budget updated successfully",
    vendorAdded: "Vendor added successfully",
    vendorAndBudgetUpdated: "Vendor and budget updated successfully",
    vendorUpdated: "Vendor updated successfully"
  }
};
